import { CloudFrontSigner } from '../../../utils/cloud-front-signer/cloud-front-signer';
import { OrthoTileStore } from './ortho-tile-store';

export class SignedCloudFrontUrlOrthoTileStore implements OrthoTileStore {
  constructor(private orthoTileCloudFrontSigner: CloudFrontSigner) {}

  async loadTileUrl(zoom: number, column: number, row: number) {
    return Promise.resolve(
      this.orthoTileCloudFrontSigner.getSignedRequest(`${zoom}/${column}/${row}.png`),
    );
  }
}
